<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入活动名称" v-model="searchVal" @change="getData" style="width:240px;margin-right:30px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button  class="top-btn" type="success" plain @click="handleShow()">添加</el-button >
        </div>
        <el-card >
            <el-table :data="tableData"  height="580">
                <el-table-column prop="title" label="活动名称" align="center"></el-table-column>
                <el-table-column prop="start_time_date" label="开始时间"  align="center"></el-table-column>
                <el-table-column prop="end_time_date" label="结束时间"  align="center"></el-table-column>
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                       <el-link type="info" v-if="scope.row.status == 0">未开始</el-link>
                       <el-link type="success" v-if="scope.row.status == 1">进行中</el-link>
                       <el-link type="danger" v-if="scope.row.status == 2">已结束</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center" width="285">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini"  @click="goDetail(scope.row)">详情</el-button>
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="600px" align="center">
           <el-row class="line-item">
               <el-col :span="4" class="item-label">活动名称：</el-col>
               <el-col :span="20">
                   <el-input placeholder="活动名称" v-model="title"></el-input>
               </el-col>
           </el-row>
           <el-row class="line-item">
               <el-col :span="4" class="item-label">开始时间：</el-col>
               <el-col :span="20">
                   <el-date-picker v-model="start_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间" style="width:100%"></el-date-picker>
               </el-col>
           </el-row>
           <el-row class="line-item">
                <el-col :span="4" class="item-label">结束时间：</el-col>
                <el-col :span="20">
                    <el-date-picker v-model="end_time" value-format="timestamp"  type="datetime" placeholder="选择结束时间" style="width:100%"></el-date-picker>
                </el-col>
           </el-row>
           <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>



    </section>
</template>
<script>
import {  active_list, active_add, active_put, active_del  } from '@/api/market.js'
import { parseTime } from '@/untils/index.js'
export default {
    data() {
        return {
            searchVal: '',
            tableData:[],
            table_load:false,
            total:0,
            page: 1,
            size: 0,
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加广告位',
            id:'',           //  有id 是修改  没有id是添加
            title:'',
            start_time:'',
            end_time:'',
            disabled: false,
            row: {}
        }
    },
    methods: {
        getData() {
            let params = {
                page:this.page,
            }
            if(this.searchVal != '') {
                params.search = this.searchVal
            }
            active_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        // 显示 添加 || 修改 弹窗
        handleShow(row) {
            this.dialog = true
            if(row) {
                this.row = row
                this.dialogTitle = '修改活动'
                this.id = row.id
                this.title = row.title
                this.start_time = new Date(row.start_time_date)
                this.end_time = new Date(row.end_time_date)
            } else {
                this.dialogTitle = '添加活动'
                this.id = ''
                this.title = ''
                this.start_time = ''
                this.end_time = ''
            }
        },
        // 弹窗里面 点击确定
        handleBtn() {
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
        },
        // 添加 活动
        handleAdd() {
            if(this.title == "") {
                this.$message.error("请输入名称!")
                return false
            }
            if(this.start_time == "") {
                this.$message.error("请选择开始时间!")
                return false
            }
            if(this.end_time == "") {
                this.$message.error("请选择结束时间!")
                return false
            }
            let params = {
                title: this.title,
                start_time: parseTime(this.start_time/1000),
                end_time: parseTime(this.end_time/1000)
            }
            this.disabled = true
            active_add(params).then(res => {
                if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                    this.dialog   = false
                }
            }).finally( () => {
                this.disabled = false
            })
        },
        // 修改 活动
        handlePut() {
            if(this.title == "") {
                return false
            }
            if(this.id == "") {
                return false
            }
            if(this.start_time == "") {
                return false
            }
            if(this.end_time == "") {
                return false
            }
            let params = {
                title: this.title,
            }
            if(new Date(this.row.start_time_date).getTime() != new Date(this.start_time).getTime()) {
                params.start_time = parseTime(this.start_time/1000)
            }
            if(new Date(this.row.end_time_date).getTime() != new Date(this.end_time).getTime()) {
                params.end_time = parseTime(this.end_time/1000)
            }
            this.disabled = true
            active_put(this.id, params).then(res => {
               if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                    this.dialog   = false
                }
            }).finally( () => {
                this.disabled = false
            })
        },
        // 删除 活动
        handleDel(row) {
            this.$confirm(`此操作将删除活动："${row.title}"，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                active_del(row.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            }).catch(() => {
                          
            });
        },
        // 跳转活动详情
        goDetail(row) {
            this.$router.push( {path: `/market/active/activity/${row.id}`, query: { title: row.title }} )
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
}
</style>
